import { ComponentPropsWithoutRef } from "react";
import PatientStatus from "../../model/PatientStatus";
import cn from "../../util/cn";

type PatientStatusCapsuleProps = {
  status: PatientStatus;
} & Omit<ComponentPropsWithoutRef<"span">, "children">;

const PatientStatusCapsule = ({ status, className }: PatientStatusCapsuleProps) => {
  return (
    <span
      title={titleForPatientStatus(status)}
      className={cn(
        "flex items-center rounded-full px-3 py-1",
        backgroundColorForPatientStatus(status),
        textColorForPatientStatus(status),
        className
      )}
    >
      <span className="truncate">{titleForPatientStatus(status)}</span>
    </span>
  );
};

const textColorForPatientStatus = (status: PatientStatus) => {
  switch (status) {
    case "onboarding":
      return "text-sky-500";
    case "monitoring":
      return "text-emerald-500";
    case "offboarded":
      return "text-gray-500";
    case "postpartum-monitoring":
      return "text-yellow-500";
  }
};

const backgroundColorForPatientStatus = (status: PatientStatus) => {
  switch (status) {
    case "onboarding":
      return "bg-sky-500/10";
    case "monitoring":
      return "bg-green-500/10";
    case "offboarded":
      return "bg-gray-500/10";
    case "postpartum-monitoring":
      return "bg-yellow-500/10";
  }
};

const titleForPatientStatus = (status: PatientStatus) => {
  switch (status) {
    case "onboarding":
      return "Onboarding";
    case "monitoring":
      return "Monitoring";
    case "offboarded":
      return "Offboarded";
    case "postpartum-monitoring":
      return "PP monitoring";
  }
};

export default PatientStatusCapsule;
